const pixel = document.querySelector("img[data-meta-pixel-src]")

// No SDK: Meta never reads the document, forms, referrer, UTM or financial pages.
if (pixel && !location.hash && !pixel.dataset.sent) {
  pixel.dataset.sent = "true"
  pixel.src = pixel.dataset.metaPixelSrc
}

document.addEventListener("turbo:before-cache", () => pixel?.remove(), { once: true })
